<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>كشوف التحصيل</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع كشوف التحصيل
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <div class='col-lg-3 col-md-3 col-sm-6'>
                                      <label>الفرع</label>
                                      <select  @change='UpdateData($event.target.value)' class="form-control"  v-model="branche">
                                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-6'>
                                        <label>الفنى:</label>
                                        <select class="form-control"  v-model="collector_id">
                                          <option v-for="(item) in emps" v-bind:key="item.id" v-bind:value="item.id">
                                            {{ item.name }}
                                          </option>
                                        </select>
                                 </div>
                                    <div class='col-lg-2 col-md-2 col-sm-6'>
                                        <label>من:</label>
                                        <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='date_even'></Datepicker>
                                    </div>
                                    <div class='col-lg-2 col-md-2 col-sm-6'>
                                        <label>الى:</label>
                                        <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='date_to'></Datepicker>
                                    </div>
                                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> عرض </b>
                                        </button>
                                    </div>
                                    <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                        <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> طباعة </b>
                                        </button>
                                    </div>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <div id="contentToPrint">
                                      <div class='col-lg-4 col-md-4 col-sm-4'>
                                        <label for="">اسم الفنى: {{title_name}}</label>
                                      </div>
                                      <div class='col-lg-4 col-md-4 col-sm-4'>
                                        <label for="">من: {{title_from}}</label>
                                      </div>
                                      <div class='col-lg-4 col-md-4 col-sm-4'>
                                        <label for="">الى: {{title_to}}</label>
                                      </div>
                                      <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                          <thead>
                                            <tr>
                                              <th style='padding:2px;text-align: center'>م</th>
                                              <th style='padding:2px;text-align: center'>السجل</th>
                                              <th style='padding:2px;text-align: center'>الاسم</th>
                                              <th style='padding:2px;text-align: center'>اسم الشهرة</th>
                                              <th style='padding:2px;text-align: center'>المحافظة</th>
                                              <th style='padding:2px;text-align: center'>المدينة</th>
                                              <th style='padding:2px;text-align: center'>الخط</th>
                                              <th style='padding:2px;text-align: center'>المحمول</th>
                                              <th style='padding:2px;text-align: center'>المطلوب</th>
                                              <th style='padding:2px;text-align: center'>المديونية</th>
                                              <th style='padding:2px;text-align: center'>التاريخ</th>
                                              <th style='padding:2px;text-align: center'>الايصال</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                                                 <td align='center'>{{index +1 }}</td>
                                                 <td align='center'>{{record.rec_id}}</td>
                                                 <td align='center'>{{record.name}}</td>
                                                 <td align='center'>{{record.nickname}}</td>
                                                <td align='center'>{{record.gov}}</td>
                                                <td align='center'>{{record.city}}</td>
                                                <td align='center'>{{record.itiname}}</td>
                                                <td align='center'>{{record.mobile}}</td>
                                                <td align='center'>{{record.note}}</td>
                                                <td align='center'>{{record.balance}}</td>
                                                <td align='center'>{{record.request_date}}</td>
                                                <td align='center'>{{record.code}}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  name: 'collectingStatement',
  data () {
    return {
      ar: ar,
      validationErrors: '',
      records: {},
      record: {},
      branches: {},
      branche: '',
      types: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: '',
      emps: {},
      emp: '',
      collector_id: 0,
      date_even: '',
      date_to: '',
      title_name: '',
      title_from: '',
      title_to: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = this.branches[0].id
    this.UpdateData(this.branche)
  },
  methods: {
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.emps = this.branches[i].technicals
      }
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getMaintenanceSheet', {
        token: localStorage.getItem('token'),
        collector_id: this.collector_id,
        date_even: this.date_even,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data.rec
          this.title_name = data.name
          this.title_from = data.from
          this.title_to = data.to
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/MaintenanceStatement.vue